// extracted by mini-css-extract-plugin
export default {"e404Wrapper":"E404_e404Wrapper__6+YzD","e404":"E404_e404__+Gf3y","banner":"E404_banner__ZN6yI","title":"E404_title__tPV-y","btnWrapper":"E404_btnWrapper__MnIfB"};